import { useFrontendUpdate, type UseFrontendUpdateOptions } from "@canucci/base/frontend-update";
import { Affix, Button, Group, Notification, Text } from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";
import { productDialogSurfaceStyles, productDialogTitleStyles } from "../theme/productDialog";
import { useState } from "react";
import { productNotificationProps, productPrimaryButtonProps, productQuietButtonProps } from "../theme/productChrome";

export type FrontendUpdatePromptProps = UseFrontendUpdateOptions;

export function FrontendUpdatePrompt(props: FrontendUpdatePromptProps) {
  const { updateAvailable, availableVersion, reload } = useFrontendUpdate(props);
  const [ignoredVersion, setIgnoredVersion] = useState<string | null>(null);

  if (!updateAvailable || availableVersion === ignoredVersion) return null;

  return (
    <Affix position={{ top: 20, right: 20 }} zIndex={2000}>
      <Notification
        {...productNotificationProps}
        styles={{
          ...productNotificationProps.styles,
          root: productDialogSurfaceStyles,
          title: productDialogTitleStyles,
        }}
        title="A new version is ready"
        icon={<IconRefresh size={20} />}
        onClose={() => setIgnoredVersion(availableVersion)}
        withCloseButton
        w="min(420px, calc(100vw - 40px))"
      >
        <Text size="sm" lh={1.5} mb="md" c="inherit">
          Reload to get the latest improvements and avoid errors from running an outdated version.
        </Text>
        <Group justify="flex-end" gap="xs">
          <Button
            radius="xl"
            {...productQuietButtonProps}
            size="sm"
            onClick={() => setIgnoredVersion(availableVersion)}
          >
            Later
          </Button>
          <Button
            radius="xl"
            {...productPrimaryButtonProps}
            size="sm"
            leftSection={<IconRefresh size={16} />}
            onClick={reload}
          >
            Reload
          </Button>
        </Group>
      </Notification>
    </Affix>
  );
}
